// ═══════════════════════════════════════════════════════════════
// Battle Rhythm — Module Layout with sub-navigation
// ═══════════════════════════════════════════════════════════════

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Group, Button, Tooltip } from '../../components/gab/GabComponents';
import {
  IconLayoutDashboard, IconTemplate, IconPresentation,
} from '@tabler/icons-react';
import { useAuthStore } from '../../store/authStore';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/battlerhythm', icon: IconLayoutDashboard, exact: true },
  { label: 'Templates', path: '/battlerhythm/templates', icon: IconTemplate, minLevel: 'editor' },
];

export default function BRLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { activeIncident } = useAuthStore();
  const visibleItems = useFilteredNav('battlerhythm', NAV_ITEMS);

  return (
    <div style={{ padding: '24px' }}>
      <Group gap="xs" mb="md" style={{ borderBottom: '1px solid var(--frost)', paddingBottom: 12 }}>
        {visibleItems.map(item => {
          const active = item.exact ? pathname === item.path : pathname.startsWith(item.path);
          return (
            <Button
              key={item.path}
              variant={active ? 'filled' : 'light'}
              color={active ? brand.blurple : 'gray'}
              size="xs"
              leftSection={<item.icon size={14} />}
              onClick={() => navigate(item.path)}
            >
              {item.label}
            </Button>
          );
        })}

        {/* Display Board link */}
        {activeIncident && (
          <Tooltip label="Open fullscreen display board" withArrow>
            <Button
              variant="light"
              color="violet"
              size="xs"
              leftSection={<IconPresentation size={14} />}
              onClick={() => navigate('/battlerhythm/display')}
              ml="auto"
            >
              Display Board
            </Button>
          </Tooltip>
        )}
      </Group>
      <Outlet />
    </div>
  );
}
